export const FORM_ITEM_STYLE = {}
